<div class="subscription-tiers-container">
    <h2 class="section-title">{{ 'aumico_components_subscription_tiers_section_title' | i18next }}</h2>
    
    <div class="tiers-grid">
        <div 
            *ngFor="let tier of tiers" 
            class="tier-card"
            [ngClass]="{
                'tier-selected': tier.isCurrentPackage,
                'tier-default': !tier.isCurrentPackage
            }"
        >
            <div 
                *ngIf="tier.isCurrentPackage" 
                class="current-package-header"
            >
                {{ 'aumico_components_subscription_tiers_current_package' | i18next }}
            </div>
            <div 
                *ngIf="!tier.isCurrentPackage" 
                class="current-package-header"
            >
                &nbsp;
            </div>

            <div class="tier-content">
                <div class="tier-header">
                    <h3 class="tier-name">{{ tier.displayName | i18next }}</h3>
                    <span 
                        *ngIf="tier.badge" 
                        hamBadge
                        [color]="'primary'"
                        [size]="'small'"
                        class="popular-badge"
                    >
                        {{ tier.badge | i18next }}
                    </span>
                </div>

                <ul class="features-list">
                    <li 
                        *ngFor="let feature of tier.features" 
                        class="feature-item"
                    >
                        <span class="ham-icon">
                            <i class="check-circle"></i>
                        </span>
                        <span class="feature-name">{{ feature.name | i18next }}</span>
                    </li>
                </ul>

                <div class="tier-footer">
                    <ham-button
                        *ngIf="!tier.isCurrentPackage"
                        [variant]="'white'"
                        [outline]="true"
                        [size]="'base'"
                        (buttonClick)="onSwitchTier(tier.id)"
                        class="switch-button"
                    >
                        {{ 'aumico_components_subscription_tiers_switch_to' | i18next: { tierName: (tier.name | i18next) } }}
                    </ham-button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="help-section">
    <h3 class="help-title">{{ 'aumico_components_subscription_tiers_help_title' | i18next }}</h3>
    <p class="help-description">{{ 'aumico_components_subscription_tiers_help_description' | i18next }}</p>
    <ham-button
        [variant]="'white'"
        [outline]="true"
        [size]="'base'"
        (buttonClick)="onContactSales()"
        class="contact-sales-button"
    >
        {{ 'aumico_components_subscription_tiers_contact_sales' | i18next }}
    </ham-button>
</div>

<ham-modal
    *ngIf="showDowngradeDialog"
    [size]="'sm'"
    [title]="'aumico_ui_billing_downgrade_title' | i18next"
    [hideFooter]="true"
    (cancel)="onCancelDowngrade()"
>
<div class="subscription-modal-container">
    <p>{{ 'aumico_ui_billing_downgrade_confirm' | i18next }}&nbsp;{{ downgradeWarningFeatures }}</p>
    <p>{{ 'aumico_ui_billing_downgrade_warning_data_loss' | i18next }}</p>

    <div class="workflow-buttons">
        <span>
            <ham-button
                class="workflow-cancel-button"
                size="sm"
                (buttonClick)="onCancelDowngrade()"
                type="submit"
                variant="transparent-gray"
                outline="true"
            >
                {{ 'aumico_ui_action_close' | i18next }}
            </ham-button>
        </span>
        <span>
            <ham-button
                class="workflow-confirm-button"
                size="sm"
                variant="red"
                (buttonClick)="onConfirmDowngrade()"
                type="submit"
            >
                {{ 'aumico_ui_action_downgrade' | i18next }}
            </ham-button>
        </span>
    </div>
</div>
</ham-modal>
<ham-modal
    *ngIf="showUpgradeDialog"
    [size]="'sm'"
    [title]="'aumico_ui_billing_upgrade_title' | i18next"
    [hideFooter]="true"
    (cancel)="onCancelUpgrade()"
>
    <div class="subscription-modal-container">

        <p>{{ 'aumico_ui_billing_upgrade_confirm' | i18next }}</p>

            <div class="workflow-buttons">
        <span>
            <ham-button
                class="workflow-cancel-button"
                size="sm"
                (buttonClick)="onCancelUpgrade()"
                type="submit"
                variant="transparent-gray"
                outline="true"
            >
                {{ 'aumico_ui_action_close' | i18next }}
            </ham-button>
        </span>
        <span>
            <ham-button
                class="workflow-confirm-button"
                size="sm"
                (buttonClick)="onConfirmUpgrade()"
                variant="primary"
                type="submit"
            >
                {{ 'aumico_ui_action_upgrade' | i18next }}
            </ham-button>
        </span>
    </div>
    </div>
</ham-modal>